import classes from './About.module.css';

const About = () => {
    return (
        <div className={classes.about}>
            <div className={classes.container}>
                <h1 className={classes.pageTitle}>About EmpireService</h1>
                <p className={classes.pageDescription}>
                    EmpireService provides expert repair services for all major home appliances with over 15 years of experience.
                </p>

                <section className={classes.companyIntro}>
                    <div className={classes.introContent}>
                        <h2>Who We Are</h2>
                        <p>
                            At EmpireService, we have 15 years of experience in appliance repair, specializing in 
                            washing machines, refrigerators, and microwave ovens. Our technicians are committed to providing 
                            fast and reliable service, ensuring your appliances are up and running in no time. Trust us for 
                            quality repairs you can count on!
                        </p>
                        <p>
                            We are a leading independent, private multi-brand service provider dedicated to delivering 
                            exceptional repair solutions for all major home appliances across Mumbai.
                        </p>
                    </div>
                    <div className={classes.introStats}>
                        <div className={classes.statItem}>
                            <div className={classes.statNumber}>15+</div>
                            <div className={classes.statLabel}>Years Experience</div>
                        </div>
                        <div className={classes.statItem}>
                            <div className={classes.statNumber}>10000+</div>
                            <div className={classes.statLabel}>Happy Customers</div>
                        </div>
                        <div className={classes.statItem}>
                            <div className={classes.statNumber}>24/7</div>
                            <div className={classes.statLabel}>Service Available</div>
                        </div>
                        <div className={classes.statItem}>
                            <div className={classes.statNumber}>30min</div>
                            <div className={classes.statLabel}>Response Time</div>
                        </div>
                    </div>
                </section>

                <section className={classes.ourStory}>
                    <h2>Our Story</h2>
                    <div className={classes.storyContent}>
                        <p>
                            Founded with a mission to provide reliable and affordable appliance repair services, 
                            EmpireService has grown from a small service center to one of Mumbai's most trusted 
                            appliance repair companies. Our journey began 15 years ago with a simple goal: to help 
                            families keep their home appliances running smoothly without breaking the bank.
                        </p>
                        <p>
                            Over the years, we've built a team of highly skilled technicians who specialize in repairing 
                            all types of home appliances. Our commitment to quality service, customer satisfaction, and 
                            fair pricing has earned us the trust of thousands of Mumbai residents.
                        </p>
                        <p>
                            Today, we continue to uphold our founding principles of integrity, reliability, and 
                            excellence in every repair job we undertake. Whether it's a refrigerator that won't cool, 
                            a washing machine that won't spin, or a microwave that won't heat, we have the expertise 
                            to get it fixed right the first time.
                        </p>
                    </div>
                </section>

                <section className={classes.ourMission}>
                    <div className={classes.missionGrid}>
                        <div className={classes.missionCard}>
                            <div className={classes.missionIcon}>🎯</div>
                            <h3>Our Mission</h3>
                            <p>
                                To provide fast, reliable, and affordable appliance repair services that exceed 
                                customer expectations and ensure complete satisfaction.
                            </p>
                        </div>
                        <div className={classes.missionCard}>
                            <div className={classes.missionIcon}>👁️</div>
                            <h3>Our Vision</h3>
                            <p>
                                To become Mumbai's most trusted appliance repair service provider known for 
                                quality workmanship, transparent pricing, and exceptional customer service.
                            </p>
                        </div>
                        <div className={classes.missionCard}>
                            <div className={classes.missionIcon}>💎</div>
                            <h3>Our Values</h3>
                            <p>
                                Integrity, reliability, transparency, and customer satisfaction are the core 
                                values that guide everything we do at EmpireService.
                            </p>
                        </div>
                    </div>
                </section>

                <section className={classes.ourTeam}>
                    <h2>Our Expert Team</h2>
                    <p className={classes.teamDescription}>
                        Our team consists of professionally qualified and experienced technicians who possess 
                        the skills to handle all types of appliance repairs. Each technician undergoes rigorous 
                        training and stays updated with the latest repair techniques and technologies.
                    </p>
                    <div className={classes.teamFeatures}>
                        <div className={classes.teamFeature}>
                            <div className={classes.featureIcon}>🔧</div>
                            <h4>Skilled Technicians</h4>
                            <p>15+ years average experience in appliance repair</p>
                        </div>
                        <div className={classes.teamFeature}>
                            <div className={classes.featureIcon}>📚</div>
                            <h4>Continuous Training</h4>
                            <p>Regular updates on latest appliance technologies</p>
                        </div>
                        <div className={classes.teamFeature}>
                            <div className={classes.featureIcon}>🛡️</div>
                            <h4>Background Verified</h4>
                            <p>All technicians are thoroughly background checked</p>
                        </div>
                        <div className={classes.teamFeature}>
                            <div className={classes.featureIcon}>🏆</div>
                            <h4>Certified Professionals</h4>
                            <p>Industry-certified repair specialists</p>
                        </div>
                    </div>
                </section>

                <section className={classes.disclaimer}>
                    <h2>Important Notice</h2>
                    <div className={classes.disclaimerContent}>
                        <div className={classes.disclaimerIcon}>⚖️</div>
                        <div className={classes.disclaimerText}>
                            <h3>Disclaimer</h3>
                            <p><strong>Important Notice to Our Customers:</strong></p>
                            <p>
                                EmpireService is an independent, private multi-brand service provider.
                            </p>
                            <p><strong>Non-Affiliation:</strong> We are not an authorized service center for any brand 
                            (Siemens, Bosch, IFB, LG, Samsung, etc.). All brand names and logos belong to their 
                            respective owners and are used for identification purposes only.
                            </p>
                            <p>
                                We provide independent repair services using our expertise and genuine spare parts 
                                to ensure the best possible service for our customers.
                            </p>
                        </div>
                    </div>
                </section>

                <section className={classes.cta}>
                    <h2>Ready to Experience Our Service?</h2>
                    <p>
                        Join thousands of satisfied customers who trust EmpireService for all their 
                        appliance repair needs. Contact us today for fast, reliable service.
                    </p>
                    <div className={classes.ctaButtons}>
                        <a href="tel:8879552122" className={classes.callButton}>Call Now</a>
                        <a href="#contact" className={classes.contactButton}>Contact Us</a>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default About;